import DynamicProviderKey from "@/model/provider/DynamicProviderKey"

const registry = {
    group: {},

    provider: {
        claritypay_standard: {
            paymentPlanOption: () => import("@/components/provider/claritypay/ClarityPayPaymentPlanOption"),
        },
        proceed_standard: {
            paymentPlanOption: () => import("@/components/provider/proceed/ProceedPaymentPlanOption"),
            paymentPlanImage: () => import("@/components/provider/proceed/ProceedPaymentPlanImage"),
        },
        lendingclub_standard: {
            paymentPlanOption: () => import("@/components/provider/lendingclub/LendingClubPaymentPlanOption"),
        },
        synchrony_standard: {
            paymentPlanOption: () => import("@/components/provider/synchrony/SynchronyPaymentPlanOption"),
            learnHowDrawer: () => import("@/components/provider/synchrony/SynchronyLearnHowDrawer"),
            existingAccountPlanOption: () =>
                import("@/components/provider/synchrony/SynchronyExistingAccountPlanOption"),
        },
        hfd_standard: {
            paymentPlanOption: () => import("@/components/provider/hfd/HfdPaymentPlanOption"),
            downpaymentSupportedAssociations: () =>
                import("@/components/provider/hfd/HfdDownpaymentSupportedAssociations"),
        },
    },
}

const cache = {}

function buildCacheKey(type, groupId, providerKey) {
    let key = type
    if (groupId) key += "." + groupId
    if (providerKey) key += "." + providerKey
    return key
}

export default {
    findComponent(type, groupId, providerKey) {
        if (!type) return null

        providerKey = DynamicProviderKey.extractProviderKey(providerKey)

        const cacheKey = buildCacheKey(type, groupId, providerKey)

        let component = cache[cacheKey]

        if (component) return component
        if (component === false) return null

        if (groupId && providerKey) {
            if (registry.group[groupId]?.provider[providerKey]?.[type]) {
                component = registry.group[groupId]?.provider[providerKey]?.[type]
            }
        }

        if (!component && groupId) {
            if (registry.group[groupId]?.[type]) {
                component = registry.group[groupId]?.[type]
            }
        }

        if (!component && providerKey) {
            if (registry.provider[providerKey]?.[type]) {
                component = registry.provider[providerKey]?.[type]
            }
        }

        cache[cacheKey] = component || false

        return component
    },
}
